export default {
	InvitationCode: "Код Приглашения",
	CreditScore: "Кредитный Рейтинг",
	MyFinancial: {
		title: "Мои Финансы",
		menu: ["Депозит", "Вывод", "Транзакция"]
	},
	MyDetail: {
		title: "Мои Данные",
		menu: ["Личная Информация", "Способы Оплаты"]
	},
	Other: {
		title: "Другое",
		menu: ["Связаться с нами", "Уведомления", "Сменить язык"]
	},
	Amount: ["Баланс Кошелька", "Замороженный Баланс", "Заработок на сегодня"],
	Logout: {
		title: "Выйти",
		content: "Вы уверены, что хотите выйти?"
	}
};
